import React from "react";
import "./Header.css";
import IMAGES from "../assets/images";
import {
  FaHome,
  FaUser,
  FaCalendarAlt,
  FaComments,
  FaMoneyCheckAlt,
  FaCog,
} from "react-icons/fa";
const Header = () => {
  return (
    <header className="header">
      <div className="header-left">
        <img src={IMAGES.webLogo} alt="Logo" className="logo" />
      </div>
      <nav className="header-center">
        <ul className="nav-list">
          <li>
            <a href="#overview" className="nav-item">
              <FaHome className="nav-icon" />
              Overview
            </a>
          </li>
          <li>
            <a href="#patient" className="nav-item">
              <FaUser className="nav-icon" />
              Patient
            </a>
          </li>
          <li>
            <a href="#schedule" className="nav-item">
              <FaCalendarAlt className="nav-icon" />
              Schedule
            </a>
          </li>
          <li>
            <a href="#message" className="nav-item">
              <FaComments className="nav-icon" />
              Message
            </a>
          </li>
          <li>
            <a href="#transaction" className="nav-item">
              <FaMoneyCheckAlt className="nav-icon" />
              Transaction
            </a>
          </li>
        </ul>
      </nav>

      <div className="header-right">
        <div className="doctor-profile">
          <img src={IMAGES.doctor_img} alt="" />
          <p>
          <span className="doctor-name">Dr. John Doe</span>
          <span className="doctor-specialization">Cardiologist</span>
          </p>
          <FaCog className="settings-icon" />
          <div className="patient-menu">⋮</div>
        </div>
      </div>
    </header>
  );
};

export default Header;
